export const hiddenBlocksBannerCopies = {
  single: {
    message: '1 bloque está oculto por la configuración de la preview.',
    action: 'Verlo',
  },
  multiple: {
    message: '{{count}} bloques están ocultos por la configuración de la preview.',
    action: 'Ver todos',
  },
}
